export const PROPERTIES_MAP = 'PROPERTIES_MAP';
export const NEARBY_PROPERTIES_MAP = 'NEARBY_PROPERTIES_MAP';
export const SINGLE_PROPERTY_MAP = 'SINGLE_PROPERTY_MAP';
